/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AdminSettings<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  instagramPosts = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminSettings/InstagramPosts`, method: "GET", secure: true, ...params });
  setInstagramPosts = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminSettings/InstagramPosts`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
}
